import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService, ConfigServiceModel } from '@app/origami-api/services/config.service';
import { TopicTypeId } from '@app/origami-api/constants/topic-type-names';
import { map } from 'rxjs/operators';
import { FieldNames } from '@app/origami-api/constants/field-names';
import { FieldsDependency } from '@app/shared/forms/dynamic-form/fields.service';
import { localizeFieldsTitles } from '@app/shared/forms/dynamic-form/dynamic-form.utils';

export interface ContactTypeTitles {
  sponsorContact: string;
  siteActivationSpecialist: string;
  siteActivationSpecialistAcronym: string;
  principalInvestigator: string;
}

export interface InvSiteCustomForm {
  fieldsDependencies: FieldsDependency[];
  contactTypeTitles: ContactTypeTitles;
}

@Injectable()
export class InvSiteCustomFormService {
  private readonly strings = tiStrings.services.contactTypeTitles.stringsContactTypeTitles;

  constructor(private readonly configService: ConfigService) {}

  getInvSiteCustomForm(roomId: number): Observable<InvSiteCustomForm> {
    // TODO: move this call to the DefaultFormsService
    return this.configService
      .searchCustomForms({
        siteId: roomId,
        topicTypeId: TopicTypeId.InvestigativeSiteInDataRoom,
        // TODO: investigate why the TopicTypeId values are not populated when a user opens a document in a separate viewer by a link
      })
      .pipe(
        map((res) => {
          if (res.Success && res.Result && res.Result.length) {
            const form = localizeFieldsTitles(res.Result[0]);
            return {
              fieldsDependencies: form.FieldsDependencies,
              contactTypeTitles: this.getContactTypes(form.FormFields),
            };
          }
          return {
            fieldsDependencies: [],
            contactTypeTitles: tiStrings.services.contactTypeTitles.stringsContactTypeTitles,
          };
        }),
      );
  }

  private getContactTypes(fields: ConfigServiceModel.Field[]): ContactTypeTitles {
    let contactTypes: ContactTypeTitles = {
      sponsorContact: '',
      siteActivationSpecialist: '',
      siteActivationSpecialistAcronym: '',
      principalInvestigator: '',
    };

    fields.forEach((field) => {
      switch (field.FieldName) {
        case FieldNames.InvestigativeSite.SponsorContact:
          contactTypes.sponsorContact = field && field.Title ? field.Title : this.strings.sponsorContact;
          break;
        case FieldNames.InvestigativeSite.StartupSpecialist:
          contactTypes.siteActivationSpecialist =
            field && field.Title ? field.Title : this.strings.siteActivationSpecialist;
          contactTypes.siteActivationSpecialistAcronym = (
            field && field.Title ? field.Title : this.strings.siteActivationSpecialist
          )
            .match(/\b(\w)/g)
            ?.join('');
          break;
        case FieldNames.InvestigativeSite.PrincipalInvestigator:
          contactTypes.principalInvestigator = field && field.Title ? field.Title : this.strings.principalInvestigator;
          break;
      }
    });

    return contactTypes;
  }
}
